import { render, staticRenderFns } from "./InvoiceAddPage.vue?vue&type=template&id=68491292&"
import script from "./InvoiceAddPage.vue?vue&type=script&lang=js&"
export * from "./InvoiceAddPage.vue?vue&type=script&lang=js&"
import style0 from "./InvoiceAddPage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports